export type SeoLocale = "en" | "zh-Hant";

export interface SeoDefaults {
  title: string;
  description: string;
  keywords: string[];
  canonical?: string;
  ogImage?: string;
}

const defaultSeoByLocale: Record<SeoLocale, SeoDefaults> = {
  "zh-Hant": {
    title: "首頁 | 基本法問答比賽 2025-26",
    description:
      "基本法問答比賽 2025-26 旨在加深市民對憲法與基本法關係、基本法歷史以及國家安全的認識，掌握比賽詳情與最新消息。",
    keywords: ["基本法", "問答", "比賽", "2025-26", "香港", "學生", "法治"],
    canonical: "https://www.cpce.gov.hk/basiclaw2025-26/",
    ogImage: "https://www.cpce.gov.hk/basiclaw2025-26/assets/ogImage.png",
  },
  en: {
    title: "Home | Basic Law Quiz Competition 2025-26",
    description:
      "The Basic Law Quiz Competition 2025-26 highlights the link between the Constitution and the Basic Law, tracing its history while promoting national security awareness.",
    keywords: [
      "Basic Law",
      "Quiz",
      "Competition",
      "2025-26",
      "Hong Kong",
      "Students",
      "Civic Education",
    ],
    canonical: "https://www.cpce.gov.hk/basiclaw2025-26/en/",
    ogImage: "https://www.cpce.gov.hk/basiclaw2025-26/assets/home/ogImage.png",
  },
};

export const getDefaultSeo = (locale?: SeoLocale): SeoDefaults =>
  defaultSeoByLocale[locale ?? "zh-Hant"] ?? defaultSeoByLocale["zh-Hant"];

export const buildCanonicalUrl = (
  relativePath: string,
  locale?: SeoLocale,
): string | undefined => {
  const seo = getDefaultSeo(locale);
  if (!seo.canonical) return undefined;
  try {
    const base = seo.canonical.endsWith("/") ? seo.canonical : `${seo.canonical}/`;
    return new URL(relativePath, base).toString();
  } catch {
    return seo.canonical;
  }
};
